"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERISCOPE_VALIDATION_RULE_COPY = void 0;
exports.PERISCOPE_VALIDATION_RULE_COPY = {
    CODE_SNIPPET: 'Code Snippet',
    PARENT_OBJECT: 'Parent Object'
};
//# sourceMappingURL=COPY.js.map